module.exports = __webpack_public_path__ + "static/img/registration-banner.7257bf32.png";